import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import dateService from '@gem/services/date-service';

import { TIME_RESTRICTION } from 'APP/constants/voice';
import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

const UPDATE_TIME_TIMEOUT = 1000;

interface IProgressRecordPresenter {
  intervalId: ReturnType<typeof setTimeout> | null;
  time: string;
  inputPanel: InputPanel | null;
  getVoiceTime(): string;
  startTimer(): void;
  stopTimer(): void;
  onStop(): Promise<void>;
}

export const useProgressRecordPresenter = (): IProgressRecordPresenter => {
  const presenter = useLocalObservable<IProgressRecordPresenter>(() => ({
    intervalId: null,
    time: '',

    get inputPanel(): InputPanel | null {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    getVoiceTime(): string {
      return dateService.secondsToString(presenter.inputPanel?.voice?.duration || 0);
    },

    startTimer(): void {
      presenter.intervalId = setInterval(() => {
        presenter.time = presenter.getVoiceTime();

        const duration = presenter.inputPanel?.voice?.duration || 0;
        if (duration >= TIME_RESTRICTION) {
          presenter.onStop();
        }
      }, UPDATE_TIME_TIMEOUT);
    },

    stopTimer(): void {
      if (presenter.intervalId) {
        clearInterval(presenter.intervalId);
      }
    },

    async onStop(): Promise<void> {
      if (!presenter.inputPanel) {
        return;
      }

      await presenter.inputPanel.voice.stop();
      presenter.inputPanel.voice.setPreview(true);
    },
  }));

  useEffect(() => {
    presenter.time = presenter.getVoiceTime();
    presenter.startTimer();

    return () => presenter.stopTimer();
  }, []);

  return presenter;
};
